export default "__VITE_ASSET__Y9qBEq9w__"